import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { SIGNUP_REASON_SELF_TOURING } from 'common/onboardingConstants';

import { hasRoleAnonymous, hasRoleBuyerSideAgent } from 'common/userRoles';
import branch from 'client/core/branch';
import { getUserLandingPage } from 'client/helpers/allowedRoles';

import withLocationQuery from 'client/helpers/withLocationQuery';
import withScrollToTop from 'client/helpers/withScrollToTop';

import { makeSignupReasonFromLocationQuery } from 'client/pages/Onboarding/index';
import SrLogo from 'client/components/SrLogo';
import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrGetStartedPageBody from './SrGetStartedPageBody';
import SrGetStartedBuyerSideAgent from './SrGetStartedBuyerSideAgent';

@branch({
  currentUser: ['currentUser'],
})
@withLocationQuery
@withScrollToTop
class GetStartedPage extends React.Component {
  static getPageMetadata = () => ({
    pageTitle: 'Get Started | Sunroom Rentals',
    section: 'Onboarding',
  });

  static propTypes = {
    locationQuery: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
  };

  render() {
    const { locationQuery, location, currentUser } = this.props;
    const signupReason = makeSignupReasonFromLocationQuery(locationQuery);

    if (signupReason === SIGNUP_REASON_SELF_TOURING) {
      if (hasRoleBuyerSideAgent(currentUser.roles)) {
        return <Redirect to={`/listing/${locationQuery.listingId}/self-tour/client-info`} />;
      }

      return (
        <SrGetStartedBuyerSideAgent
          location={location}
          locationQuery={locationQuery}
          currentUser={currentUser}
        />
      );
    }

    if (!hasRoleAnonymous(currentUser.roles)) {
      return <Redirect to={getUserLandingPage({ userRoles: currentUser.roles })} />;
    }

    return (
      <SrPartnerPageV2 navbarTitle={<SrLogo />}>
        <SrGetStartedPageBody location={location} />
      </SrPartnerPageV2>
    );
  }
}

GetStartedPage.displayName = 'GetStartedPage';

export default GetStartedPage;
